import React, { Component } from 'react';
import './App.css';
import Tone from 'tone';
import P5Wrapper from 'react-p5-wrapper';

const meter = new Tone.Meter();

const loop1 = new Tone.Player({
  "url": "g_001.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 15.99,
  "volume": -5
}).connect(meter).toMaster();

// const loop2 = new Tone.Player({
//   "url": "g_002.mp3",
//   "loop": "true",
//   "loopStart": 0,
//   "loopEnd": 5.31,
//   "volume": 0
// }).connect(meter).toMaster();

const loop3 = new Tone.Player({
  "url": "g_003.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 5.31,
  "volume": 0
}).connect(meter).toMaster();

const loop4 = new Tone.Player({
  "url": "g_004.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 10.65,
  "volume": -5
}).connect(meter).toMaster();

const loop5 = new Tone.Player({
  "url": "g_005.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 10.65,
  "volume": -5
}).connect(meter).toMaster();

const players = [loop1, loop3, loop4, loop5];

class App extends Component {

  componentDidMount() {
    console.log("14");
  }

  render() {
    return (
      <div className="App">
        <div className="content">
          <div className="sketch">
            <P5Wrapper sketch={sketch} />
          </div>
        </div>
      </div>
    );
  }
}

function sketch(p) {

  var diameter = 0.1;

  var bg = 75;

  var randomNo;

  var rLS1, rLS2, rLS3, rLS4, rLS5, rLS6, rLS7, rLS8, rLS9, rLS10, rLS11, rLS12, rLS13, rLS14, rLS15;
  var rLE1, rLE2, rLE3, rLE4, rLE5, rLE6, rLE7, rLE8, rLE9, rLE10, rLE11, rLE12, rLE13, rLE14, rLE15;
  var rt1, rt2, rt3, rt4, rt5, rt6, rt7, rt8, rt9, rt10, rt11, rt12, rt13, rt14, rt15;
  var rb1, rb2, rb3, rb4, rb5, rb6, rb7, rb8, rb9, rb10, rb11, rb12, rb13, rb14, rb15;

  var rLS = [rLS1, rLS2, rLS3, rLS4, rLS5, rLS6, rLS7, rLS8, rLS9, rLS10, rLS11, rLS12, rLS13, rLS14, rLS15];
  var rLE = [rLE1, rLE2, rLE3, rLE4, rLE5, rLE6, rLE7, rLE8, rLE9, rLE10, rLE11, rLE12, rLE13, rLE14, rLE15];
  var rt = [rt1, rt2, rt3, rt4, rt5, rt6, rt7, rt8, rt9, rt10, rt11, rt12, rt13, rt14, rt15];
  var rb = [rb1, rb2, rb3, rb4, rb5, rb6, rb7, rb8, rb9, rb10, rb11, rb12, rb13, rb14, rb15];

  var rLSoff1, rLSoff2, rLSoff3, rLSoff4, rLSoff5, rLSoff6, rLSoff7, rLSoff8, rLSoff9, rLSoff10, rLSoff11, rLSoff12, rLSoff13, rLSoff14, rLSoff15;
  var rLEoff1, rLEoff2, rLEoff3, rLEoff4, rLEoff5, rLEoff6, rLEoff7, rLEoff8, rLEoff9, rLEoff10, rLEoff11, rLEoff12, rLEoff13, rLEoff14, rLEoff15;
  var rtoff1, rtoff2, rtoff3, rtoff4, rtoff5, rtoff6, rtoff7, rtoff8, rtoff9, rtoff10, rtoff11, rtoff12, rtoff13, rtoff14, rtoff15;
  var rboff1, rboff2, rboff3, rboff4, rboff5, rboff6, rboff7, rboff8, rboff9, rboff10, rboff11, rboff12, rboff13, rboff14, rboff15;

  var rLSoff = [rLSoff1, rLSoff2, rLSoff3, rLSoff4, rLSoff5, rLSoff6, rLSoff7, rLSoff8, rLSoff9, rLSoff10, rLSoff11, rLSoff12, rLSoff13, rLSoff14, rLSoff15];
  var rLEoff = [rLEoff1, rLEoff2, rLEoff3, rLEoff4, rLEoff5, rLEoff6, rLEoff7, rLEoff8, rLEoff9, rLEoff10, rLEoff11, rLEoff12, rLEoff13, rLEoff14, rLEoff15];
  var rtoff = [rtoff1, rtoff2, rtoff3, rtoff4, rtoff5, rtoff6, rtoff7, rtoff8, rtoff9, rtoff10, rtoff11, rtoff12, rtoff13, rtoff14, rtoff15];
  var rboff = [rboff1, rboff2, rboff3, rboff4, rboff5, rboff6, rboff7, rboff8, rboff9, rboff10, rboff11, rboff12, rboff13, rboff14, rboff15];

  for (var i = 0; i < 15; i++) {
    rLSoff[i] = 0.0;
    rLEoff[i] = 0.0;
    rtoff[i] = 0.0;
    rboff[i] = 0.0;
  }

  p.setup = function () {
    p.createCanvas(p.windowWidth, p.windowHeight);
    p.cursor(p.ARROW);
    p.frameRate(30);
  }

  p.draw = function () {
    p.noStroke();
    p.rect(p.windowWidth / 2 - (diameter / 2), p.windowHeight / 2 - (diameter / 2), diameter, diameter);
    p.fill(100);

    var level = meter.getLevel();

    if (diameter > 0.1) {
      p.clear();
      p.rect(p.windowWidth / 2 - (diameter / 2), p.windowHeight / 2 - (diameter / 2), diameter, diameter);
      diameter = diameter - 0.2;
    }

    if (p.mouseIsPressed || p.touchStarted) {
      p.background(bg);
      if (bg === 75) {
        bg = 150;
      }
      else {
        bg = 75;
      }

      diameter++;
      p.noStroke();
      p.fill((level * -2.5) * 5);
      p.rect(p.windowWidth / 2 - (diameter / 2), p.windowHeight / 2 - (diameter / 2), diameter, diameter);


      p.stroke((level * -2.5) * 6);

      for (var i = 0; i < 12; i++) {
        rLSoff[i] = rLSoff[i] + Math.random() * 0.05;
        rLS[i] = p.noise(rLSoff[i]) * p.windowHeight;
        rLEoff[i] = rLEoff[i] + Math.random() * 0.05;
        rLE[i] = p.noise(rLEoff[i]) * p.windowHeight;
        p.line(0, rLS[i], p.windowWidth, rLE[i]);
      }

      for (i = 12; i < 15; i++) {
        rLSoff[i] = rLSoff[i] + Math.random() * 1;
        rLS[i] = p.noise(rLSoff[i]) * p.windowHeight;
        rLEoff[i] = rLEoff[i] + Math.random() * 1;
        rLE[i] = p.noise(rLEoff[i]) * p.windowHeight;
        p.line(0, rLS[i], p.windowWidth, rLE[i]);
      }

      for (i = 0; i < 13; i++) {
        rtoff[i] = rtoff[i] + Math.random() * 0.05;
        rt[i] = p.noise(rtoff[i]) * p.windowWidth;
        rboff[i] = rboff[i] + Math.random() * 0.05;
        rb[i] = p.noise(rboff[i]) * p.windowWidth;
        p.line(rt[i], 0, rb[i], p.windowHeight);
      }

      for (i = 13; i < 15; i++) {
        rtoff[i] = rtoff[i] + Math.random() * 1;
        rt[i] = p.noise(rtoff[i]) * p.windowWidth;
        rboff[i] = rboff[i] + Math.random() * 1;
        rb[i] = p.noise(rboff[i]) * p.windowWidth;
        p.line(rt[i], 0, rb[i], p.windowHeight);
      }
    }

    if (diameter > p.windowWidth || diameter > p.windowHeight) {
      window.location = "../";
    }


  }

  p.windowResized = function windowResized() {
    p.resizeCanvas(p.windowWidth, p.windowHeight);
  };

  p.mousePressed = function mousePressed() {
    randomNo = Math.floor(Math.random() * Math.floor(players.length));
    players[randomNo].start();

    for (var i = 0; i < 15; i++) {
      rLS[i] = Math.floor(Math.random() * Math.floor(p.windowHeight));
      rLE[i] = Math.floor(Math.random() * Math.floor(p.windowHeight));
      rt[i] = Math.floor(Math.random() * Math.floor(p.windowWidth));
      rb[i] = Math.floor(Math.random() * Math.floor(p.windowWidth));
    }

  }

  p.mouseReleased = function mouseReleased() {
    for (var i = 0; i < players.length; i++) {
      players[i].stop();
    }
    p.clear();
    p.rect(p.windowWidth / 2 - (diameter / 2), p.windowHeight / 2 - (diameter / 2), diameter, diameter);
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js